import {Component} from '@angular/core';
import {Router} from '@angular/router';

//import {GoogleAnalytics} from '@awesome-cordova-plugins/google-analytics/ngx';
import {StatusbarService} from '../../core/native/statusbar/statusbar.service';
import {UnrRouteListItem} from '../roadtrip-list/roadtrip-list-item/model/route-list-item.model';
import {MyRoutesStateService} from './my-routes.state.service';
import {Platform} from '@ionic/angular';


@Component({
  selector: 'unr-my-routes',
  templateUrl: 'my-routes.html',
  styleUrls: [
    'my-routes.scss'
  ]
})
export class MyRoutesPage {

  trips: UnrRouteListItem[];

  constructor(public router: Router,
              private stateService: MyRoutesStateService,
             // private googleAnalytics: GoogleAnalytics,
              private statusbarService: StatusbarService,
              private platform: Platform) {
  }

  ionViewWillEnter(): void {
    if (this.platform.is('ios')) {
      this.statusbarService.changeStatusBar({ style: '' });
    } else {
      this.statusbarService.changeStatusBar({ style: '' });
    }
   // this.googleAnalytics.trackView('Profile -> My rides');
    this.trips = this.stateService.roadTrips;
  }
}
